import React from "react";

const Grupo4 = ({datos,handleChange,eliminarFila}) => {

    return (

        <div>

            <div className="table-responsive">

                <table className="table align-middle">

                    <thead className="table-secondary">

                        <tr>

                            <th style={{ width: "70%" }}>Etapa</th>
                            <th style={{ width: "180px" }}># Apadrinados</th>
                            <th style={{ width: "80px" }}>Acción</th>

                        </tr>

                    </thead>

                    <tbody>

                        {

                            datos.length === 0 &&

                            <tr>

                                <td colSpan={3} className="text-center">
                                    No hay registros. Presione "Agregar fila" para comenzar.
                                </td>

                            </tr>

                        }

                        {

                            datos.map((item, index) => (

                                <tr key={index}>

                                    <td>

                                        <select className="form-select"
                                            value={item.etapa || ""}
                                            onChange={(e) =>
                                                handleChange(
                                                    index,
                                                    "etapa",
                                                    e.target.value
                                                )
                                            }
                                        >

                                            <option value=""hidden>Seleccione</option>
                                            <option value="Infancia">Infancia</option>
                                            <option value="Juventud">Juventud</option>
                                            <option value="Orientación profesional">Orientación profesional</option>
                                            <option value="Educación superior">Educación superior</option>

                                        </select>

                                    </td>

                                    <td>
                                        <input
                                            type="number"
                                            className="form-control"
                                            min="0"
                                            step="1"
                                            value={item.num_apadrinados ?? ""}
                                            onChange={(e) =>
                                                handleChange(
                                                    index,
                                                    "num_apadrinados",
                                                    e.target.value
                                                )
                                            }
                                        />
                                    </td>

                                    <td className="text-center">

                                        <button className="btn btn-sm btn-danger" onClick={() =>eliminarFila(index)}>
                                            <i className="bi bi-trash"></i>
                                        </button>

                                    </td>

                                </tr>

                            ))

                        }

                    </tbody>

                </table>

            </div>

        </div>

    );

};

export default Grupo4;